import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';
import RoundedLink from '../elements/RoundedLink';
import InternalLink from '../elements/InternalLink';
import { logoutAnaliticsRoute } from '../../config/routes';
import LinkButton from "../elements/form/button/LinkButton";

export default class MenuUserItems extends React.PureComponent {
    state = {
        isMenuOpen: false,
    };
    componentDidMount() {
        window.addEventListener("keydown", this.escHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.escHandler);
    }
    escHandler = event => {
        if (event.keyCode === 27) {
            this.closeUserMenu();
        }
    };
    logOut = () => {
        let { logout, registerPageView } = this.props;

        logout();

        registerPageView(logoutAnaliticsRoute.title, logoutAnaliticsRoute.path);
    };
    renderUserPopup = () => {
        const { isMenuOpen } = this.state;
        const { isGetMePending } = this.props;

        if (!isMenuOpen || isGetMePending) {
            return false;
        }

        return (
            <div className={'toggle-menu'} onClick={this.closeUserMenu}>
                <div className={'arrow'}></div>

                <InternalLink link={'/dashboard'}>Dashboard</InternalLink>

                <LinkButton onClick={this.logOut}>Logout</LinkButton>
            </div>
        )
    };
    toggleUserMenu = () => {
        const { isMenuOpen } = this.state;

        this.setState({
            isMenuOpen: !isMenuOpen,
        });
    };
    closeUserMenu = () => {
        this.setState({
            isMenuOpen: false,
        });
    }
    renderUserButtons = () => {
        let {
            isLogged,
            userData,
            isSignUpAvailable,
            isGetMePending,
        } = this.props;
        let { isMenuOpen } = this.state;

        if (isLogged) {
            const userText = userData.name !== '' ? userData.name : userData.email;
            return (
                <div className={`logged-menu-container ${isMenuOpen ? ' opened' : ''}`}>
                    <div onClick={this.closeUserMenu} className={'logged-menu-shade'}></div>

                    <div className={'logged-menu'}>
                        {isGetMePending ? <div className={'user-data-loading'}>
                            <span>Loading user...</span>
                            <img alt={'Loading'} src={require('../../assets/images/loader.gif')}/>
                        </div> : <div className={'username'} onClick={this.toggleUserMenu}>
                            <div title={userText} className={'text'}>{userText}</div>
                            <img alt={'email verified'} src={require('../../assets/images/icons/user-menu-arrow-down.svg')}/>
                        </div>}

                        {this.renderUserPopup()}
                    </div>
                </div>

            );
        }

        return (
            <div className={'unlogged-links'}>
                <MenuItem className={'login-link'} link={'/login'} text={'Login'}/>
                {isSignUpAvailable ? <RoundedLink className={'sign-up-link'} link={'/signup'} text={'Sign Up'}/> : false}
            </div>
        )
    };

    render() {
        return (
            <div className={'menu-user-items'}>
                {this.renderUserButtons()}
            </div>
        );
    }
}

MenuUserItems.propTypes = {
    userData: PropTypes.object.isRequired,
    isLogged: PropTypes.bool.isRequired,
    isSignUpAvailable: PropTypes.bool.isRequired,
    isGetMePending: PropTypes.bool.isRequired,
    registerPageView: PropTypes.func.isRequired,
};
